import { mapToCanActivate, mapToResolve, Routes } from '@angular/router';
import { AtLeastAdvisorRoleGuard } from '@next/core-lib/authorization';
import { LocationGuard } from '@next/core-lib/relationships';
import { Observable } from 'rxjs';

import { CreateReferenceSchemeComponent } from './components/create-reference-scheme/create-reference-scheme.component';
import { ReferenceSchemeOverviewComponent } from './components/reference-scheme-overview/reference-scheme-overview.component';
import { ReferenceScheme } from './models/reference-scheme.model';
import { GetReferenceSchemeByIdResolver } from './resolvers/get-reference-scheme-by-id.resolver';
import { ReferenceSchemeOverviewResolver } from './resolvers/reference-scheme-overview.resolver';

export const ReferenceSchemeRoutes: Routes = [
  {
    path: '',
    component: ReferenceSchemeOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(ReferenceSchemeOverviewResolver),
    },
  },
  {
    path: 'create',
    component: CreateReferenceSchemeComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      data: mapToResolve<Observable<boolean>>(ReferenceSchemeOverviewResolver),
    },
  },
  {
    path: 'edit/:id',
    component: CreateReferenceSchemeComponent,
    canActivate: mapToCanActivate([LocationGuard, AtLeastAdvisorRoleGuard]),
    resolve: {
      referenceScheme: mapToResolve<Observable<ReferenceScheme>>(GetReferenceSchemeByIdResolver),
    },
  },
  {
    path: 'view/:id',
    component: CreateReferenceSchemeComponent,
    canActivate: mapToCanActivate([LocationGuard]),
    resolve: {
      referenceScheme: mapToResolve<Observable<ReferenceScheme>>(GetReferenceSchemeByIdResolver),
    },
  },
];
